import { ApiStatus, ApiStatusActionType } from "../actionTypes/apiStatusActionTypes";

export const setPostApiStatus = (payload: boolean): ApiStatusActionType => ({
  type: ApiStatus.SET_POST_API_STATUS,
  payload,
});

export const setPutApiStatus = (payload: boolean): ApiStatusActionType => ({
  type: ApiStatus.SET_PUT_API_STATUS,
  payload,
});
